// extracted by mini-css-extract-plugin
module.exports = {"Container":"Redirect_Container__2O-cM"};